export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
}

export function Avatar({ name, avatar, size = 30 }: { name: string; avatar?: string | null; size?: number }) {
  if (avatar) {
    return (
      <img
        className="avatar"
        src={avatar}
        alt={name}
        style={{ width: size, height: size, objectFit: 'cover' }}
      />
    );
  }
  return (
    <div className="avatar" style={{ width: size, height: size, fontSize: size * 0.38 }}>
      {initials(name) || '?'}
    </div>
  );
}
